import { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import "./ExportCsvButton.css";

const filenameFromHeaders = (headers, fallback) => {
  const disposition = headers?.["content-disposition"] || "";
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
  const value = utf8Match?.[1] || plainMatch?.[1];

  try {
    return value ? decodeURIComponent(value) : fallback;
  } catch {
    return value || fallback;
  }
};

const ExportCsvButton = ({ exportRequest, filters = {}, filename }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const response = await exportRequest(filters);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filenameFromHeaders(response.headers, filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("CSV export failed:", error);
      alert("Unable to export CSV. Please try again.");
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="export-csv-action">
      <button
        type="button"
        className="export-csv-button"
        onClick={handleExport}
        disabled={exporting}
        aria-busy={exporting}
      >
        <span className="export-csv-button__icon">
          <DownloadIcon fontSize="small" />
        </span>
        <span>{exporting ? "Preparing CSV..." : "Export CSV"}</span>
      </button>
    </div>
  );
};

export default ExportCsvButton;
